import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import LogoHyundai from "../../images/assets/hyundai-logo.webp";
import "./css/menu.css";
import cartIcon from "../../images/shoppingCartIcon.png";
import llaveIcon from "../../images/llaveIcon.png";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Modal } from 'react-bootstrap';
import {CartBuy} from "./CartBuy"


function MenuRepuestos({ cartItems, setShowModalCart, showModalCart, newAddProduct, minProduct }) {
  const totalPrice = cartItems.reduce((price, item) => price + item.quantity * item.price, 0);
  const totalProducts = cartItems.reduce((quantity, item) => quantity + item.quantity, 0);
  return (
    <Fragment >
      <div className="fondo"></div>
      <header className="d-none d-sm-block  ">
        <Container className="container-custom " >
          <Row className="justify-content-between ">
            <div className="barra-menu ">
              <ul className="flex-wrap">
                {/*<li >
                  <Link to="/terminos-y-condiciones" className="text-reset">
                    Términos y condiciones
                  </Link>
                </li>*/}
                <li>|</li>
                <li >
                  <Link to="/politica-privacidad" className="text-reset">
                    Políticas de privacidad y Protección de datos
                  </Link>
                </li>
                <li>|</li>
                <li>
                  <Link to="/mercado-valores" className="text-reset">
                    Mercado de valores
                  </Link>
                </li>
                <li>|</li>
                <li >
                  <Link to="/politica-calidad" className="text-reset">
                    Política de calidad
                  </Link>
                </li>
                <li>|</li>
                <li >
                  <Link to="/mision-vision" className="text-reset">
                    Misión y Visión
                  </Link>
                </li>
                <li>|</li>
                <li>
                  <Nav.Link
                    href="https://hyundai.hiringroom.com/jobs"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="nav-link-barra text-reset"
                  >
                    Trabaja con nosotros
                  </Nav.Link>
                </li>
              </ul>
            </div>
          </Row>
        </Container>
      </header>
      <div>
  <Navbar className="d-flex navbar navbar-expand-lg navbar-light bg-light">
    <Container fluid>
      <div className="d-flex justify-content-between align-items-center w-100">
        <div className="me-3">
          <Navbar.Brand as={Link} to="/" className="menu-logo-end">
            <LazyLoadImage
              src={LogoHyundai}
              alt="Logo Hyundai"
              className="logo-hyundai"
            />
          </Navbar.Brand>
        </div>
        <div className="d-flex align-items-center">
          <h1 className="Titulo-repuestos mb-0">Tienda de Partes & Accesorios Originales Hyundai</h1>
          <LazyLoadImage
            src={llaveIcon}
            alt="Llave Icon"
            className="wrench-icon mt-1"
          />
        </div>

        <div className="d-flex cart-container ms-3">
          <img
            src={cartIcon}
            alt="Carrito de compras"
            className="cart-icon"
            onClick={() => setShowModalCart(true)}
          />
        </div>
      </div>
    </Container>
  </Navbar>
</div>
      <Modal size="xl" show={showModalCart} onHide={() => setShowModalCart(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Carrito de Compras</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <CartBuy
            cartItems={cartItems}
            newAddProduct={newAddProduct}
            minProduct={minProduct}
          />
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-secondary" onClick={() => setShowModalCart(false)}>
            Cerrar
          </button>
        </Modal.Footer>
      </Modal>
    </Fragment>
  );
}
export default MenuRepuestos; 